import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { CustomerPaymentMethod } from 'src/features/paymentMethods/utils/types';

const RESOURCE = '/customers/customer-payment-method/:customerPaymentMethodId/';

type QueryFnType = typeof queryFn;

interface DTO {
    customerPaymentMethodId: string;
}
const queryFn = ({ customerPaymentMethodId }: DTO): Promise<CustomerPaymentMethod> => {
    return axios.get(formatResourcePath(RESOURCE, { customerPaymentMethodId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetCustomerPaymentMethod, RESOURCE as CUSTOMER_PAYMENT_METHOD_RESOURCE };
